<sew-wizard>
    @for (step of steps; track step; let i = $index) {
        <sew-wizard-item
            [attr.step-index]="i + 1"
            completed="{{ step.finished }}"
            active="{{ i === stepIndex }}"
        >
            <button>{{ step.data['title'] }}</button>
        </sew-wizard-item>
    }
</sew-wizard>
<ng-template *ngComponentOutlet="component; injector: contentInjector"></ng-template>
<div class="sew-dialog-button-group" [ngClass]="{ 'multiple-buttons': stepIndex > 0 }">
    @if (stepIndex > 0) {
        <sew-button hierarchy="tertiary">
            <button (click)="back()">
                {{ 'CONFIGURATION.WIZARD.BACK' | translate }}
            </button>
        </sew-button>
    }
    @if (stepIndex < steps.length - 1) {
        <sew-button hierarchy="primary" website>
            <button (click)="next()" [disabled]="(valid | async) === false">
                {{ 'CONFIGURATION.WIZARD.NEXT' | translate }}
            </button>
        </sew-button>
    }
    @if (stepIndex === steps.length - 1) {
        <sew-button hierarchy="primary" website icon="shopping-cart">
            <button (click)="close()" [disabled]="(valid | async) === false">
                {{ 'CONFIGURATION.WIZARD.ADD' | translate }}
            </button>
        </sew-button>
    }
</div>
